import React from "react";
import g from "glamorous";
import Link, { navigateTo } from "gatsby-link";
import { translate } from "react-i18next";

import generalStyles from "../utils/generalStyles";
import colors from "../utils/colors";
import { scrollTo } from "../utils/functions";

import LanguageSwitcher from "../components/languageSwitcher";
import GhostButton from "../components/ghostButton";

import contact from "../assets/svgs/contact.svg";
import facebookIcon from "../assets/svgs/facebook.svg";
import logo from "../assets/svgs/logo.svg";

const TopBar = g.div({
	backgroundColor: "white",
	height: "4rem",
	display: "flex",
	justifyContent: "center",
	alignItems: "center",
	borderBottom: `1px solid ${colors.mischka}`,
	[generalStyles.mediaQueries.lg]: {
		justifyContent: "start",
		paddingLeft: "2rem"
	},
	[generalStyles.mediaQueries.md]: {
		justifyContent: "start",
		padding: "0 4rem"
	},
	...generalStyles.visibility("xs", false)
});

const SocialIconLink = g.a({
	display: "inline-block"
});

const SocialIcon = g.img({
	display: "block",
	height: "1.25rem",
	margin: 0
});

const Actions = g.div({
	position: "absolute",
	right: "1rem",
	top: 0,
	display: "flex",
	alignItems: "center",
	height: "4rem",
	[generalStyles.mediaQueries.md]: {
		right: "4rem"
	}
});

const HeaderArea = g.div({
	height: "8rem",
	backgroundColor: "white",
	padding: "1.75rem 2rem",
	display: "flex",
	justifyContent: "space-between",
	[generalStyles.mediaQueries.lg]: {
		padding: "1.75rem 4rem"
	},
	[generalStyles.mediaQueries.xs]: {
		padding: "24px 24px 16px",
		height: "auto",
		marginBottom: 24
	}
});

const Logo = g.img({
	height: "100%",
	[generalStyles.mediaQueries.xs]: {
		width: 120
	}
});

const NavLinks = g.div({
	alignSelf: "flex-end",
	marginBottom: "1rem",
	"> a, > button": {
		marginLeft: "4rem",
		transition: generalStyles.transition,
		background: "transparent",
		padding: 0,
		border: 0,
		color: colors.fiord,
		cursor: "pointer",
		":hover": {
			color: colors.danube
		}
	},
	[generalStyles.mediaQueries.xs]: {
		marginBottom: 0,
		marginTop: 32,
		"> a, > button": {
			marginLeft: "2rem"
		}
	}
});

const HeaderWrapper = g.div({
	position: "relative",
	zIndex: 1
});

const MobileTop = g.div({
	...generalStyles.visibility("xs"),
	display: "none",
	position: "absolute",
	right: "1.5rem",
	top: "1.5rem",
	lineHeight: "normal"
});

const MobileContact = g.img({
	width: 24,
	verticalAlign: "middle",
	display: "none"
});

class Header extends React.Component {
	componentWillMount() {}

	moveToBottom() {
		if (document) {
			if (window.location.pathname.includes("news")) {
				navigateTo("#footer");
			} else {
				scrollTo(document.getElementById("map-section").offsetTop, 800);
			}
		}
	}

	render() {
		const { t } = this.props;
		return (
			<HeaderWrapper>
				<TopBar>
					<div className="size-14 weight-medium color-aluminum letter-spacing-bigger">
						{t("top_text")}
					</div>
					<Actions>
						<SocialIconLink
							href="https://www.facebook.com/PeriklisPasxakisLawFirm/"
							target="_blank"
						>
							<SocialIcon src={facebookIcon} />
						</SocialIconLink>
						<LanguageSwitcher />
					</Actions>
				</TopBar>
				<HeaderArea>
					<Link
						activeStyle={{ cursor: "default" }}
						to="/"
						style={{ position: "relative", height: "100%" }}
						exact={true}
					>
						<Logo src={logo} />
					</Link>
					<MobileTop className="size-12 color-aluminum weight-medium">
						{t("top_text")}
					</MobileTop>
					<NavLinks className="header-links size-14">
						<Link
							activeStyle={{ color: colors.danube }}
							className="weight-medium"
							to="/news"
						>
							{t("news")}
						</Link>
						<button
							onClick={() => this.moveToBottom()}
							className="weight-medium"
						>
							<MobileContact
								css={generalStyles.visibility(
									"xs",
									true,
									"inline-block"
								)}
								src={contact}
							/>
							<span css={generalStyles.visibility("xs", false)}>
								{t("contact")}
							</span>
						</button>
					</NavLinks>
				</HeaderArea>
			</HeaderWrapper>
		);
	}
}

export default translate()(Header);



// WEBPACK FOOTER //
// ./src/components/header.js